if (!window.SubcollectionCarousel) {
  window.SubcollectionCarousel = class {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.section = document.querySelector(`.subcollection-section-${sectionId}`);
      this.carousel = document.getElementById(`subcol-carousel-${sectionId}`);
      
      if (!this.carousel || !this.section) return;
      
      this.init();
    }
    
    init() {
      this.track = document.getElementById(`subcol-carousel-track-${this.sectionId}`);
      this.viewport = this.carousel.querySelector('.subcol-carousel-viewport');
      this.pagination = document.getElementById(`subcol-carousel-pagination-${this.sectionId}`);
      this.prevBtns = this.carousel.querySelectorAll('.subcol-carousel-arrow[data-direction="prev"]');
      this.nextBtns = this.carousel.querySelectorAll('.subcol-carousel-arrow[data-direction="next"]');
      
      this.navigation = this.carousel.dataset.navigation;
      this.mobileNavigation = this.carousel.dataset.mobileNavigation;
      this.enableAutoscroll = this.carousel.dataset.autoscroll === 'true';
      this.autoscrollInterval = parseInt(this.carousel.dataset.autoscrollInterval) * 1000;
      this.mobileEnableAutoscroll = this.carousel.dataset.mobileAutoscroll === 'true';
      this.mobileAutoscrollInterval = parseInt(this.carousel.dataset.mobileAutoscrollInterval) * 1000;
      
      const styles = getComputedStyle(this.section);
      this.totalItems = parseInt(styles.getPropertyValue('--subcol-total-items'));
      this.itemsToMove = parseInt(styles.getPropertyValue('--subcol-items-to-move'));
      this.desktopColumns = parseInt(styles.getPropertyValue('--subcol-desktop-columns'));
      this.mobileColumns = parseInt(styles.getPropertyValue('--subcol-mobile-columns'));
      
      this.currentIndex = 0;
      this.visibleItems = window.innerWidth >= 750 ? this.desktopColumns : this.mobileColumns;
      this.maxIndex = Math.max(0, Math.ceil((this.totalItems - this.visibleItems) / this.itemsToMove));
      this.autoscrollTimer = null;
      this.isDragging = false;
      this.isHorizontalScroll = null;
      
      this.bindEvents();
      this.updateCarousel();
      this.updatePaginationVisibility();
      
      if (this.getCurrentAutoscroll() && this.isCarouselLayout()) {
        this.startAutoscroll();
      }
    }
    
    isCarouselLayout() {
      const isDesktop = window.innerWidth >= 750;
      if (isDesktop) {
        return this.section.classList.contains('layout-desktop-carousel');
      } else {
        return this.section.classList.contains('layout-mobile-carousel') || 
               this.section.classList.contains('layout-mobile-carousel-simple');
      }
    }
    
    getCurrentNavigation() {
      return window.innerWidth >= 750 ? this.navigation : this.mobileNavigation;
    }
    
    getCurrentAutoscroll() {
      return window.innerWidth >= 750 ? this.enableAutoscroll : this.mobileEnableAutoscroll;
    }
    
    getCurrentAutoscrollInterval() {
      return window.innerWidth >= 750 ? this.autoscrollInterval : this.mobileAutoscrollInterval;
    }
    
    updateArrowVisibility() {
      const isDesktop = window.innerWidth >= 750;
      const desktopArrows = this.carousel.querySelectorAll('.desktop-only');
      const mobileArrows = this.carousel.querySelectorAll('.mobile-only');
      
      if (isDesktop) {
        desktopArrows.forEach(arrow => arrow.style.display = '');
        mobileArrows.forEach(arrow => arrow.style.display = 'none');
      } else {
        desktopArrows.forEach(arrow => arrow.style.display = 'none');
        mobileArrows.forEach(arrow => {
          if (this.section.classList.contains('layout-mobile-carousel') && 
              this.mobileNavigation === 'arrows') {
            arrow.style.display = '';
          } else {
            arrow.style.display = 'none';
          }
        });
      }
    }
    
    updateCarousel() {
      if (!this.track || !this.isCarouselLayout()) return;
      
      const itemWidth = this.track.children[0] ? this.track.children[0].offsetWidth : 0;
      const gap = parseInt(getComputedStyle(this.section).getPropertyValue('--subcol-item-gap'));
      this.visibleItems = window.innerWidth >= 750 ? this.desktopColumns : this.mobileColumns;
      this.maxIndex = Math.max(0, Math.ceil((this.totalItems - this.visibleItems) / this.itemsToMove));
      this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
      
      const moveDistance = (itemWidth + gap) * this.currentIndex * this.itemsToMove;
      this.track.style.transform = `translateX(-${moveDistance}px)`;
      
      this.prevBtns.forEach(btn => btn.disabled = this.currentIndex === 0);
      this.nextBtns.forEach(btn => btn.disabled = this.currentIndex >= this.maxIndex);
      
      if (this.pagination && this.getCurrentNavigation() === 'dots') {
        const dots = this.pagination.querySelectorAll('.subcol-pagination-dot');
        const isDesktop = window.innerWidth >= 750;
        const currentPages = isDesktop ? 
          Math.ceil((this.totalItems - this.desktopColumns) / this.itemsToMove) + 1 : 
          Math.ceil((this.totalItems - this.mobileColumns) / this.itemsToMove) + 1;
        
        dots.forEach((dot, index) => {
          if (index < currentPages) {
            dot.style.display = '';
            dot.classList.toggle('active', index === this.currentIndex);
          } else {
            dot.style.display = 'none';
          }
        });
      }
      
      this.updateArrowVisibility();
    }
    
    updatePaginationVisibility() {
      if (this.pagination) {
        const isDesktop = window.innerWidth >= 750;
        const shouldShow = this.isCarouselLayout() && (
          (isDesktop && this.navigation === 'dots') || 
          (!isDesktop && this.section.classList.contains('layout-mobile-carousel') && 
           this.mobileNavigation === 'dots')
        );
        this.pagination.style.display = shouldShow ? 'flex' : 'none';
      }
    }
    
    startAutoscroll() {
      if (!this.getCurrentAutoscroll() || !this.isCarouselLayout()) return;
      const interval = this.getCurrentAutoscrollInterval();
      this.autoscrollTimer = setInterval(() => {
        this.visibleItems = window.innerWidth >= 750 ? this.desktopColumns : this.mobileColumns;
        this.maxIndex = Math.max(0, Math.ceil((this.totalItems - this.visibleItems) / this.itemsToMove));
        this.currentIndex = this.currentIndex >= this.maxIndex ? 0 : this.currentIndex + 1;
        this.updateCarousel();
      }, interval);
    }
    
    stopAutoscroll() {
      if (this.autoscrollTimer) clearInterval(this.autoscrollTimer);
    }
    
    bindEvents() {
      this.prevBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (!this.isCarouselLayout()) return;
          this.currentIndex = Math.max(0, this.currentIndex - 1);
          this.updateCarousel();
          if (this.getCurrentAutoscroll()) {
            this.stopAutoscroll();
            this.startAutoscroll();
          }
        });
      });

      this.nextBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (!this.isCarouselLayout()) return;
          this.visibleItems = window.innerWidth >= 750 ? this.desktopColumns : this.mobileColumns;
          this.maxIndex = Math.max(0, Math.ceil((this.totalItems - this.visibleItems) / this.itemsToMove));
          this.currentIndex = Math.min(this.maxIndex, this.currentIndex + 1);
          this.updateCarousel();
          if (this.getCurrentAutoscroll()) {
            this.stopAutoscroll();
            this.startAutoscroll();
          }
        });
      });

      if (this.pagination) {
        const dots = this.pagination.querySelectorAll('.subcol-pagination-dot');
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            if (!this.isCarouselLayout()) return;
            this.currentIndex = index;
            this.updateCarousel();
            if (this.getCurrentAutoscroll()) {
              this.stopAutoscroll();
              this.startAutoscroll();
            }
          });
        });
      }

      if (this.viewport) {
        const handleTouchStart = (e) => {
          if (!this.isCarouselLayout() || this.section.classList.contains('layout-mobile-carousel-simple')) return;
          this.startX = e.touches ? e.touches[0].clientX : e.clientX;
          this.startY = e.touches ? e.touches[0].clientY : e.clientY;
          this.currentX = this.startX;
          this.currentY = this.startY;
          this.isDragging = true;
          this.isHorizontalScroll = null;
          this.stopAutoscroll();
        };

        const handleTouchMove = (e) => {
          if (!this.isDragging || !this.isCarouselLayout() || 
              this.section.classList.contains('layout-mobile-carousel-simple')) return;
          this.currentX = e.touches ? e.touches[0].clientX : e.clientX;
          this.currentY = e.touches ? e.touches[0].clientY : e.clientY;
          
          if (this.isHorizontalScroll === null) {
            const deltaX = Math.abs(this.currentX - this.startX);
            const deltaY = Math.abs(this.currentY - this.startY);
            if (deltaX > deltaY && deltaX > 5) {
              this.isHorizontalScroll = true;
            } else if (deltaY > deltaX && deltaY > 5) {
              this.isHorizontalScroll = false;
            }
          }
          
          if (this.isHorizontalScroll) {
            e.preventDefault();
          }
        };

        const handleTouchEnd = () => {
          if (!this.isDragging || !this.isCarouselLayout() || 
              this.section.classList.contains('layout-mobile-carousel-simple')) return;
          
          const diff = this.startX - this.currentX;
          const threshold = 50;
          
          if (Math.abs(diff) > threshold) {
            if (diff > 0 && this.currentIndex < this.maxIndex) {
              this.currentIndex++;
            } else if (diff < 0 && this.currentIndex > 0) {
              this.currentIndex--;
            }
            this.updateCarousel();
          }
          
          this.isDragging = false;
          if (this.getCurrentAutoscroll()) {
            this.startAutoscroll();
          }
        };

        this.viewport.addEventListener('touchstart', handleTouchStart, { passive: false });
        this.viewport.addEventListener('touchmove', handleTouchMove, { passive: false });
        this.viewport.addEventListener('touchend', handleTouchEnd);
        this.viewport.addEventListener('mousedown', handleTouchStart);
        this.viewport.addEventListener('mousemove', handleTouchMove);
        this.viewport.addEventListener('mouseup', handleTouchEnd);
        this.viewport.addEventListener('mouseleave', handleTouchEnd);
      }

      window.addEventListener('resize', () => {
        this.visibleItems = window.innerWidth >= 750 ? this.desktopColumns : this.mobileColumns;
        this.updateCarousel();
        this.updatePaginationVisibility();
        if (this.getCurrentAutoscroll() && this.isCarouselLayout()) {
          this.stopAutoscroll();
          this.startAutoscroll();
        }
      });

      const observer = new MutationObserver(() => {
        this.updateCarousel();
        this.updatePaginationVisibility();
        if (this.getCurrentAutoscroll() && this.isCarouselLayout()) {
          this.stopAutoscroll();
          this.startAutoscroll();
        }
      });
      observer.observe(this.section, { attributes: true, attributeFilter: ['class'] });
    }
  };

  function initAllCarousels() {
    document.querySelectorAll('[data-subcollection-carousel]').forEach(function(element) {
      const sectionId = element.dataset.subcollectionCarousel;
      if (!element.dataset.initialized) {
        new SubcollectionCarousel(sectionId);
        element.dataset.initialized = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
  
  document.addEventListener('shopify:section:load', initAllCarousels);
}